// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-summary {
  margin-top: 10px;
}

.ai-summary-label {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.ai-summary-spark {
  color: #0d6efd;
  font-size: 12px;
  line-height: 1;
}

.ai-summary-box {
  width: 100%;
  min-height: 42px;
  background-color: var(--white);
  border: var(--border-style);
  border-radius: var(--border-sm-radius);
  color: var(--primary-font-color);
  padding: 7px 8px;
  white-space: pre-wrap;
}

.ai-summary-text {
  line-height: 1.35;
}

.ai-summary-meta {
  color: var(--secondary-font-color);
  font-size: 11px;
  margin-top: 6px;
}

.ai-summary-meta span::before {
  content: " | ";
}

.ai-summary-stale {
  color: var(--warning-color);
  font-weight: 600;
}

.ai-summary-muted,
.ai-summary-empty {
  color: var(--secondary-font-color);
}`, "",{"version":3,"sources":["webpack://./src/app/cp/dispatches/dispatch-summary/dispatch-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,oBAAA;EACA,QAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,2BAAA;EACA,sCAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,kCAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,kCAAA;AACJ","sourcesContent":[".ai-summary {\n    margin-top: 10px;\n}\n\n.ai-summary-label {\n    align-items: center;\n    display: inline-flex;\n    gap: 4px;\n}\n\n.ai-summary-spark {\n    color: #0d6efd;\n    font-size: 12px;\n    line-height: 1;\n}\n\n.ai-summary-box {\n    width: 100%;\n    min-height: 42px;\n    background-color: var(--white);\n    border: var(--border-style);\n    border-radius: var(--border-sm-radius);\n    color: var(--primary-font-color);\n    padding: 7px 8px;\n    white-space: pre-wrap;\n}\n\n.ai-summary-text {\n    line-height: 1.35;\n}\n\n.ai-summary-meta {\n    color: var(--secondary-font-color);\n    font-size: 11px;\n    margin-top: 6px;\n}\n\n.ai-summary-meta span::before {\n    content: ' | ';\n}\n\n.ai-summary-stale {\n    color: var(--warning-color);\n    font-weight: 600;\n}\n\n.ai-summary-muted,\n.ai-summary-empty {\n    color: var(--secondary-font-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
